import { useOrganization } from "@clerk/clerk-react";
import { Trans } from "@lingui/react/macro";
import {
  Anchor,
  Button,
  Center,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconArrowLeft, IconLock } from "@tabler/icons-react";
import {
  createFileRoute,
  useCanGoBack,
  useNavigate,
  useRouter,
} from "@tanstack/react-router";

import { HeaderBase, HeaderUser } from "@/components/header";

export const Route = createFileRoute("/_app/unauthorized")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organization } = useOrganization();
  const navigate = useNavigate();
  const router = useRouter();
  const canGoBack = useCanGoBack();

  const isAnyOrganizationActive = !!organization;

  return (
    <Stack>
      <HeaderBase>
        <HeaderUser />
      </HeaderBase>

      <Center h="60vh">
        <Stack align="center" gap="md">
          <IconLock size={48} color="var(--mantine-color-dimmed)" />
          <Title order={3} ta="center">
            {isAnyOrganizationActive ? (
              <Trans>Du har ikke tilgang til denne ressursen</Trans>
            ) : (
              <Trans>Ingen organisasjon valgt</Trans>
            )}
          </Title>
          <Text ta="center" c="dimmed">
            {isAnyOrganizationActive ? (
              <Trans>
                Kontakt din{" "}
                <Anchor size="md" href="mailto:post@museumnord.no">
                  administrator
                </Anchor>{" "}
                for å få tilgang til denne ressursen
              </Trans>
            ) : (
              <Trans>
                Velg organisasjon øverst til høyre eller kontakt{" "}
                <Anchor size="md" href="mailto:post@museumnord.no">
                  administrator
                </Anchor>
              </Trans>
            )}
          </Text>

          <Group>
            {canGoBack && (
              <Button
                variant="light"
                leftSection={<IconArrowLeft size={16} />}
                onClick={() => router.history.back()}
              >
                <Trans>Gå tilbake</Trans>
              </Button>
            )}
            <Button onClick={() => navigate({ to: "/" })}>
              <Trans>Gå tilbake til hovedsiden</Trans>
            </Button>
          </Group>
        </Stack>
      </Center>
    </Stack>
  );
}
